const Config = {
  de: {
    lang: 'de',
    referenceCountry: 'DE',
    selectedCountry: 'EU',
    formulaFactor: 1.06,
    showIncomeSection: true,
    appUrl: 'https://www.iwkoeln.de/__extendedmedia_resources/382502/index.html',
    embedUrl: 'https://www.iwkoeln.de/__extendedmedia_resources/382505/index.html',
    sharingText: 'Interaktive Grafik des @iw_koeln zu Einkommen in Europa:'
  },
  ch: {
    lang: 'de',
    referenceCountry: 'CH',
    selectedCountry: 'EU',
    formulaFactor: 1.7488,
    showIncomeSection: true,
    appUrl: 'https://www.iwkoeln.de/__extendedmedia_resources/382502/index.html',
    embedUrl: 'https://www.iwkoeln.de/__extendedmedia_resources/382502/index.html',
    sharingText: 'Interaktive Grafik des @iw_koeln zu Einkommen in Europa:'
  },
  uk: {
    lang: 'en',
    referenceCountry: 'UK',
    selectedCountry: 'EU',
    formulaFactor: 0.953288,
    showIncomeSection: true,
    appUrl: 'https://www.iwkoeln.de/__extendedmedia_resources/382507/index.html',
    embedUrl: 'https://www.iwkoeln.de/__extendedmedia_resources/382507/index.html',
    sharingText: 'Interactive Graphic of @iw_koeln about the Prosperity of the European States:'
  },
  int: {
    lang: 'en',
    referenceCountry: 'EU',
    selectedCountry: 'DE',
    formulaFactor: 1.04497,
    showIncomeSection: false,
    appUrl: 'https://www.iwkoeln.de/__extendedmedia_resources/374964/index.html',
    embedUrl: 'https://www.iwkoeln.de/__extendedmedia_resources/374964/index.html',
    sharingText: 'Interactive Graphic of @iw_koeln about the Prosperity of the European States:'
  }
};

export default Config;



// WEBPACK FOOTER //
// ./src/config.js